export default {"src":"/_next/static/media/Interst-calc-icon.13571be3.svg","height":27,"width":23};